/*
	Returns translated placeholder for form fields based on label translation.
	Arguments: {
		type: (String) Type of form field. One of 'text', 'number', 'select'
		placeholder: (String or false | Optional) Returns this value if it's defined (returns empty string if it's false)
		labelT: (String) Key of 'i18n'. Translation by this key is used as 'i18n' interpolation in placeholder translation
		t: (Function) 'i18n' translation function
		i18n: (Object) Insance of 'i18n' library
	}
*/

export default ({ type, placeholder, labelT, t, i18n }) => {
	// Use defined placeholder
	if(placeholder) {
		return placeholder
	}
	// Don't use any placeholder if it's defined as false
	if(placeholder === false) {
		return ''
	}
	const resolvePlaceholder = (useDefault) => {
		const placeholdersPath = 'common.placeholders'
		let resolvedPath
		switch(type) {
			case 'text': resolvedPath = `${placeholdersPath}.text${useDefault ? '_default' : ''}`
				break
			case 'select': resolvedPath = `${placeholdersPath}.select${useDefault ? '_default' : ''}`
				break
			case 'number': resolvedPath = `${placeholdersPath}.number${useDefault ? '_default' : ''}`
				break
			case 'textarea': resolvedPath = `${placeholdersPath}.textarea${useDefault ? '_default' : ''}`
				break
			case 'text_editor': resolvedPath = `${placeholdersPath}.text_editor${useDefault ? '_default' : ''}`
				break
			default: resolvedPath = ''
		}
		return resolvedPath ? t(resolvedPath, { name: t(labelT) }) : ''
	}

	// If valid 'i18n' key is provided return translation otherwise return default translation
	return labelT && i18n.exists(labelT)
		? resolvePlaceholder(false)
		: resolvePlaceholder(true)
}
